import moment from 'moment';

export const getLocalDate = (date: Date) => moment(date).local().toDate();

export const getStartOfDay = (date: Date) => moment(date).startOf('day').toDate();

export const getEndOfDay = (date: Date) => moment(date).endOf('day').toDate();
